import { PeekyEmitter } from "@shared/peeky.emitter";
import { ElementClass, UrlParam, Peeky, RootKey, StateClass, ElementUrlParam } from "./peeky";
import { PeekyState } from "./peeky.state";
import { sleep } from '@shared/sleep';

import $ from 'jquery';

type PeekyElementOptions = {
	DOM?: HTMLElement;
  $dom?: JQuery,
  site?: Peeky,
  init?: boolean,
  param?: UrlParam,
  parent?: PeekyElement,
  parentState?: PeekyState,
  initialDocument?: boolean
}
export { PeekyElementOptions };

export class PeekyElement extends PeekyEmitter {

  key: string;
  $dom?: JQuery;
	DOM: HTMLElement;
  root: PeekyElement;
  site: Peeky;

  parent: PeekyElement;
  parentState: PeekyState;
  currentState: PeekyState;
  states: PeekyState[];

  _pathLevel: number;
  _catchPath: number = 0;

  _param: UrlParam;
  _property: any;
  defaultPath: string | string[];
  lockPath: string | string[];
  catchAnchor: any;
  catchPathTree: any;
  catchParent: PeekyElement;
  multiPath: boolean | string[] | boolean[] | string[][];

  constructor(key: string, options: PeekyElementOptions, callback?: Function) {
    super();

    this.key = key;

		if (options.DOM) {
			this.DOM = options.DOM;
			this.$dom = $(options.DOM);
		} else {
			this.$dom = options.$dom;
			this.DOM = options.$dom[0];
		}
  
    if (this.$dom) {
      this.$dom.data('kkElement', this);
    }
    
    if (key == RootKey) {
      this.root = this;
      this.site = options.site;
    } else {
      this.parent = options.parent;
      this.parentState = options.parentState;
      this.root = this.parent.root;
      this.site = this.parent.site;
    }
      
    this.states = [];
    this._param = {};
    this._property = {};
    
    // Add initial actions
    for (let action in actions) {
      this.bindAction(action, actions[action]);
    }
  
    if (options.init !== false) {
      this.triggerAction('initElement', {
        param: options.param,
        initialDocument: options.initialDocument
      }).then(async () => {
        if (callback) {
					await sleep(0);
					callback.call(this);
        }
      });
    }
    
    return this;
  }


  state(serial?) {
	  if (typeof(serial) === 'undefined') {
      return this.currentState;
    }
		// Search from top-down, to find most recent entries first (when we are replacing elements etc)
		for (let i=this.states.length-1; i>=0; i--) {
			if (this.states[i].equals(serial)) {
				return this.states[i];
			}
		}
		return;
	}


  param(defaults: boolean): ElementUrlParam;
  param(values: object): ElementUrlParam;
  param(key: string, value: any): ElementUrlParam;
  param(): ElementUrlParam {
    let state = this.state();
    return state.param.apply(state, arguments);
	}
	
	
	pathLevel(): number {
		if (typeof(this._pathLevel) !== 'undefined') {
      return this._pathLevel;
    }
		else if (!this.parent) {
      this._pathLevel = this.catchPath() || 0;
    }
		else {
      this._pathLevel = this.catchPath() + this.parent.pathLevel();
    }
		return this._pathLevel;
	}


	catchPath() {
		return this._catchPath;
	}


  getArg(arg: number = 0) {
		return this.state().getArg(arg);
	}


  // If no parameters are given, use current state
	serialize(inparam, relative) {
		let param;
		if (!inparam) {
      param = this.currentState.param();
    }
		else if (relative) {
      param = $.extend(true, {}, this.currentState.param(), inparam);
    }
		else {
      param = inparam;
    }
		// Add '' for each empty argument?
		return this.site.serialize(param, relative);
	}


  $find(selector) {
		return this.$dom.find(selector).not(this.$dom.find('.' + ElementClass + ' '  + selector));
	}


  catchPathTreeCompare(path) {
    let catchParent = this.catchParent;
    if (typeof(catchParent) === 'undefined') {
      catchParent = this.parent;
      while (catchParent && catchParent.catchPath() <= 0) {
        catchParent = catchParent.parent;
      }
      this.catchParent = catchParent;
    }

    if (catchParent) {
      if (!this.catchPathTree) {
        return catchParent.catchPathTreeCompare(path);
      }
      else if (Array.isArray(path)) {
        if (path[catchParent.pathLevel()-1] !== this.catchPathTree) {
          return false;
        }
      }
      else if (typeof(path) === 'object' && path[RootKey] && path[RootKey]._arg) {
        if (path[RootKey]._arg[catchParent.pathLevel()-1] !== this.catchPathTree) {
          return false;
        }
      }
      else if (catchParent.getArg() !== this.catchPathTree) {
        return false;
      }

      return catchParent.catchPathTreeCompare(path);
    } else {
      return true;
    }
  }


    // Key/value implementations
	property(key: string | object, val?: any) {
		if (!this._property) {
      this._property = {};
    }
		if (typeof(key) === 'object') {
			val = key;
			for (let subkey in val) {
        this.property(subkey, val[subkey]);
      }
			return;
		} 
		if (typeof(val) === 'undefined') {
      return this._property[key];
    }
    this._property[key] = val; 
	}


	async reload(param) {
		await this.site.goTo(undefined, {
			reload: this.key
		});
		return;
	}
}



let actions: {
	[key: string]: (this: PeekyElement, param: any) => Promise<any>
} = {
	
	initElement: async function(this: PeekyElement, param) {
		// Get the numer of arguments this element will catch
		this._catchPath = this.$dom.data('catchpath') || 0;
		this.defaultPath = this.$dom.data('defaultpath');
		this.lockPath = this.$dom.data('lockpath');
		this.catchAnchor = this.$dom.data('catchanchor');
		this.catchPathTree = this.$dom.data('catchpathtree');
		this.multiPath = this.$dom.data('multipath');
		
		if (this.defaultPath && !Array.isArray(this.defaultPath)) {
			this.defaultPath = [this.defaultPath];
		} else if (!this.defaultPath) {
			this.defaultPath = [];
		}

		if (this.lockPath && !Array.isArray(this.lockPath)) {
			this.lockPath = [this.lockPath];
		} else if (!this.lockPath) {
			this.lockPath = [];
		}

		if (this.multiPath) {
			if (!Array.isArray(this.multiPath)) {
				this.multiPath = [];
				for (let i=0; i<this._catchPath; i++) {
					this.multiPath[i] = true;
				}
			}
		} else {
			this.multiPath = [];
		}
		
		// Initiate first state
		//(<any>this.$dom).wrapInner();

		// Root can only have one state
		if (this.key === RootKey) {
			// Root is only created on document.ready, and shouldn't have param.param
			this.currentState = new PeekyState({
        DOM: this.DOM,
        element: this,
        param: param.param,
        initialDocument: param.initialDocument
      });
			this.states.push(this.currentState);
			this.once('postLoadedElement', function triggerLoadedState(param, target) {
				if (target) {
          return this.one('postLoadedElement', triggerLoadedState);
        }
				this.currentState.triggerAction('loadedState');	
			});
		}

		// Preloaded states are found
		else if (this.$dom.data('preloadedstates')) {
			let $preloaded = this.$dom.children();
      let element = this;
			$preloaded.detach();
			$preloaded.each(function() {
				let $state = $(this);
				let stateParam = $.extend({}, param.param);
				stateParam[element.key] = $state.data('param');
				let state = new PeekyState({
          $dom: $state,
          element: element,
          initialDocument: param.initialDocument,
          param: stateParam
        });
				$state.addClass(StateClass);
				$state.addClass(StateClass + '_' + element.key);
				if (element.$dom.data('ajaxclass')) {
					$state.addClass(element.$dom.data('ajaxclass'));
				}
				element.states.push(state);
				if (!element.currentState) {
					element.currentState = state;
				}
				element.once('postLoadedElement', function triggerLoadedState(param, target) {
					if (target) {
            return element.once('postLoadedElement', triggerLoadedState);
          }
					state.triggerAction('loadedState');
				});
			});

			if (!this.currentState) {
				this.currentState = this.states[0];
			}

			this.$dom.html('');
			this.currentState.$dom.appendTo(this.$dom);
		}

		// Create initial state
		else {
			let $state = $('<div></div>').addClass( StateClass + ' ' + (this.$dom.data('ajaxclass') || '') );
			$state.addClass(StateClass + '_' + this.key);
			this.$dom.wrapInner($state);
			$state = this.$dom.children('.' + StateClass);
			this.currentState = new PeekyState({
        $dom: $state,
        element: this,
        param: param.param,
        initialDocument: param.initialDocument
      });
			this.states.push( this.currentState );
			
			// Only the initial load will be without param.param. This load will trigger loadedState separately
			this.once('postLoadedElement', function triggerLoadedState(this: PeekyElement, param, target) {
				if (target) {
          return this.one('postLoadedElement', triggerLoadedState);
        }
				this.currentState.triggerAction('loadedState');	
			});
		}
	},
	
	
	createState: async function(this: PeekyElement, param) {
		let that = this;

		function createState(data, param) {
			let $state = $('<div></div>').addClass( StateClass + ' ' + (that.$dom.data('ajaxclass') || '') );
			$state.addClass(StateClass + '_' + that.key);
			$state.html(data);
			let state = new PeekyState({
        $dom: $state,
        element: that,
        param: param,
        initialDocument: param.initialDocument
      });

			let oldState = that.state(state.serialize());
			if (oldState) {
				oldState.triggerAction('removeState');
			}
			that.states.push( state );
			state.triggerAction('loadedState');
		};

		if (param.data.m && param.data.m.defaultPath) {
			this.defaultPath = param.data.m.defaultPath;
			if (!Array.isArray(this.defaultPath)) {
				this.defaultPath = [this.defaultPath];
			}
		}
		if (param.data.m && param.data.m.lockPath) {
			this.lockPath = param.data.m.lockPath;
			if (!Array.isArray(this.lockPath)) {
				this.lockPath = [this.lockPath];
			}
		}

		if (this.$dom.data('preloadedstates')) {
			let $dom = $('<div>' + param.data.data + '</div>');
			let $children = $dom.children();
			$children.each(function() {
				let $this = $(this);
				let data = $this.html();
				let singleParam = $.extend({}, param.param);
				singleParam[that.key] = $this.data('param');
				createState(data, singleParam);
			});
		} else {
			createState(param.data.data, param.param);
		}
	},
	

	// Wrapper for "attachState" + "switchState" + "detachState"
	showState: async function(this: PeekyElement, param) {
		let that = this;
		let newState = param.state;
		let oldState = that.currentState;
		let triggerParam = {
      ...param,
			  attach: newState,
			  $attach: newState.$dom
		};
		
		// No need to switch to the same state!
		if (oldState === newState) {
			await this.triggerAction('attachState', triggerParam);
			await newState.triggerAction('stateShown', triggerParam);
			return;
		}
		
		triggerParam.detach = this.currentState;
		triggerParam.$detach = this.currentState.$dom;

		// Chain "attachState","switchState","detachState"
		await this.triggerAction('attachState', triggerParam);
    that.currentState = newState;

		await this.triggerAction('switchState', triggerParam);
		await this.triggerAction('detachState', triggerParam);

		await oldState.triggerAction('stateHidden');

    if (param.switchingParent) {
      param.switchingParent.shown(async function() {
        await newState.triggerAction('stateShown', triggerParam);
      });
    } else {
      await newState.triggerAction('stateShown', triggerParam);
    }

    // If there are more states with the same serial, remove the old ones
    // This is a cleanup step that can also happen after next() is called
    let states = that.states.slice(0);
    for (let i=0; i<states.length; i++) {
      let state = states[i];
      // *this* state
      if (state === newState) {
        continue;
      }
      // Not equal state, and we shouldn't empty the element
      if (!param.empty && !state.equals(newState)) {
        continue;
      }
      state.triggerAction('removeState');
    }
	},
	
	
	attachState: async function(this: PeekyElement, param) {
		if (!param.attach) {
      throw undefined;
    }
		
		// Mark detaching element (to enable selectors excluding the detaching element)
		if (this.key !== RootKey) {
			if (param.detach) {
				param.detach.$dom.addClass('_detaching');
				// Attaching should only be sent if we're also detaching, if not this is the initial state
				param.attach.$dom.addClass('_attaching');
			}
		}
		
		// Trigger on all children elements as well
		// TODO: CHECK: Why is this needed? Peeky.goTo should also trigger recursively
		function nextElement() {
			for (let k in this.children) {
				this.children[k].state().triggerAction('attached', param);
				nextElement.call(this.children[k].state());
			}
		}
		
		// Delay until parent is attached
		if (!$.contains(document.documentElement, param.$attach[0]) && param.$attach.parents().length > 0) {
			return;
		}
		// If it's already attached (probably it is initialized from loaded HTML code) only trigger the attached event without reattaching 
		else if ($.contains(document.documentElement, param.$attach[0]) || param.$attach.parents().length > 0) {
			param.attach.triggerAction('attached');
			nextElement.call(param.attach);
			return;
		}
		param.$attach.css('display', 'none');
		param.$attach.appendTo( this.$dom );
		await param.attach.triggerAction('attached', param);
		nextElement.call(param.attach);
	},
	
	
	detachState: async function(this: PeekyElement, param) {
		if (!param.detach) {
      param.detach = this.state();
    }
		if (!param.$detach) {
      param.$detach = param.detach.$dom;
    }
		
		// Trigger "unload" event for iframes
		param.$detach.find('iframe').each(function() {
			// Try / catch, we might not have access to this iframe if it is remote
			try {
				$(this.contentWindow).trigger('unload');
			} catch(e) {}
		});
		
		param.$detach.detach();
		param.detach.triggerAction('detached', { options: param.options });
		if (this.key !== RootKey) {
			param.$detach.removeClass('_detaching');
			if (param.$attach) {
				param.$attach.removeClass('_attaching');
			}
		}
		
		// Trigger on all attached children elements as well
		function nextElement() {
			for (let k in this.children) {
				this.children[k].state().triggerAction('detached', { options: param.options });
				nextElement.call(this.children[k].state());
			}
		}
		nextElement.call(param.detach);
	},
	
	
	postSwitchState: async function(this: PeekyElement, param) {
		param.$detach.css('display', 'none');
		param.$attach.css('display', '');
		// TODO: This will be done for *each element* !
		if (typeof(param.options.scrollTop) !== 'undefined') {
			$('body,html').scrollTop(param.options.scrollTop);
		}
		if (typeof(param.options.scrollLeft) !== 'undefined') {
			$('body,html').scrollLeft(param.options.scrollLeft);
		}
		if (param.detach) param.detach.triggerAction('switchedFrom');
		if (param.attach) param.attach.triggerAction('switchedTo');
	},


	empty: async function(this: PeekyElement, param) {
		let states = this.states.slice(0);
    for (let i=0; i<states.length; i++) {
      let state = states[i];
      state.triggerAction('removeState');
    }
	},

	
	removeElement: async function(this: PeekyElement, param) {
		if (!this.parentState) {
      throw undefined;	// Cannot remove root
    }
		
		let children = this.parentState.children;
		await this.triggerAction('empty');
    delete(children[this.key]);
    if (this.$dom) {
      this.$dom.remove();
    }
	}
};
